import { render, staticRenderFns } from "./HeaderDesktop.vue?vue&type=template&id=7c4145fc&"
import script from "./HeaderDesktop.vue?vue&type=script&lang=js&"
export * from "./HeaderDesktop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "HeaderDesktop.vue"
export default component.exports